// extracted by mini-css-extract-plugin
module.exports = {"text":"FullDealOfferActions_text__1TEIw"};